import { defineStore } from 'pinia'

const COOKIEBOT_CATEGORIES = ['necessary', 'preferences', 'statistics', 'marketing']

export const useCookieConsentStore = defineStore('cookieConsent', {
	state: () => ({
		inited: false,
		responded: false,
		categories: {
			necessary: false,
			preferences: false,
			statistics: false,
			marketing: false,
		},
		// Whether a loader-style landing wants the Cookiebot banner hidden while it's on
		// screen (so it doesn't cover the interstitial). Ephemeral — never persisted.
		bannerDeferred: false,
	}),

	getters: {
		/**
		 * Array of accepted category names — e.g. ['necessary', 'marketing'].
		 * Used for backend reporting and analytics payloads.
		 */
		getActiveGroups(state) {
			return COOKIEBOT_CATEGORIES.filter((cat) => state.categories[cat])
		},

		/**
		 * Has the user actively responded to the banner (accept or decline).
		 */
		hasResponded(state) {
			return state.responded
		},

		/**
		 * @returns {function('necessary'|'preferences'|'statistics'|'marketing'): boolean}
		 */
		isActiveConsentByName(state) {
			return (consent) => Boolean(state.categories[consent])
		},

		getIsInited(state) {
			return state.inited
		},
	},

	actions: {
		setInited(inited) {
			this.inited = inited
		},
		setResponded(responded) {
			this.responded = responded
		},
		setCategories(categories) {
			this.categories = {
				necessary: Boolean(categories.necessary),
				preferences: Boolean(categories.preferences),
				statistics: Boolean(categories.statistics),
				marketing: Boolean(categories.marketing),
			}
		},

		/**
		 * Hide the Cookiebot banner (e.g. while a loader landing is on screen).
		 */
		deferBanner() {
			this.bannerDeferred = true
		},

		/**
		 * Reveal the Cookiebot banner again. Safe to call even if it was never deferred.
		 */
		releaseBanner() {
			this.bannerDeferred = false
		},
	},
})
